import { CampaignCreate } from "./CampaignCreate";
import { CampaignEdit } from "./CampaignEdit";
import { CampaignList } from "./CampaignList";

export { CampaignCreate, CampaignEdit, CampaignList };

export default {
  list: CampaignList,
  create: CampaignCreate,
  edit: CampaignEdit,
};
